import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '../../../directives/directives.module';
import { AtomInputNoneSelectedComponent } from './atom-input-none-selected.component';
import { TranslateTokenisedStringPipe } from '@wdx/shared/utils';

@NgModule({
    imports: [CommonModule, DirectivesModule, TranslateTokenisedStringPipe],
    declarations: [AtomInputNoneSelectedComponent],
    exports: [AtomInputNoneSelectedComponent],
})
export class AtomInputNoneSelectedModule {}
